module.exports = __webpack_public_path__ + "img/picture.d7a4d0c3.png";